import { t } from "@lingui/macro";
import { useTimeTrackingUsersQuery } from "@src/__generated__/graphql";
import { onError } from "@src/utils/apollo";
import { useStore } from "@src/utils/hooks";
import mapToOptions from "@src/utils/map-to-options";
import type { Store } from "../store";

export const useFetchUsers = (store: Store) => {
  const { authStore } = useStore();
  const { loading } = useTimeTrackingUsersQuery({
    onCompleted(data) {
      store.setUsers(data);
      store.userOptions = mapToOptions.users(data.userSimpleMap, (option) =>
        authStore.user?.id === option.value
          ? {
              ...option,
              label: t`My timesheet`,
            }
          : option,
      );
    },
    ...onError(),
  });

  store.setUsersLoading(loading);
};
